// Drop menu is the menu which appears when the hamburger icon in the head menu is toggled
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { patch, elementOpen, elementClose, text } from 'incremental-dom';
import { isNil, patchElement } from '../utils';
import { linkClick } from '../rxjs';
var transitionTime = 500;
;
var headMenuStore = {
    shorten: 0,
    show: false,
    actual: 0
};
var merge = function (b, n) {
    return (__assign(__assign({}, b), n));
};
var DropMenu = function (dropmenu) {
    var dm = Object.create({});
    dm.toggle = function (force, head) { toggleSubMenu(dropmenu, force, head); };
    dm.reset = function () {
        headMenuStore = { shorten: 0, show: false, actual: 0 };
        // headMenuToggle will not work if the headmenu has re-rendered and tophovermenu no longer exists
        // so we need to force the height of the hovermenu container to zero
        var menuWrapperX = patchElement('headsubmenu');
        menuWrapperX.style.height = '0px';
        var menuWrapperXTop = patchElement('topsubmenu');
        if (menuWrapperXTop) {
            menuWrapperXTop.style.height = '0';
        }
    };
    dm.close;
    return dm;
};
var hoverMenuContent = function (dropmenu, currentLocation) {
    elementOpen('div', 'hmc', null, 'class', 'hovermenucontent');
    if (typeof dropmenu === 'function') {
        dropmenu(currentLocation);
    }
    else {
        dropmenu.map(function (c, j) {
            elementOpen('div', null, null, 'class', 'hovermenucolumn');
            elementOpen('ul');
            c.map(function (_a, i) {
                var menuText = _a.menuText, link = _a.link;
                var classList, finalMenuText;
                if (menuText[0] === '*') {
                    classList = ['class', 'drop-menu-spacer'];
                    finalMenuText = menuText.slice(1);
                }
                else {
                    classList = null;
                    finalMenuText = menuText;
                }
                elementOpen('li', null, classList);
                elementOpen('a', "hmc-" + link + "-" + i, null, 'href', link, 'class', currentLocation === link ? 'active-link' : 'other-link', 'onclick', function (event) {
                    linkClick(event, link);
                });
                text(finalMenuText);
                elementClose('a');
                elementClose('li');
            });
            elementClose('ul');
            elementClose('div');
        });
    }
    elementClose('div');
};
var patchElementClass = function (c) {
    var menuElement = document.getElementsByClassName(c);
    return isNil(menuElement) ? document.createElement("div") : menuElement[0]; // FIXME - can this really be undefined
};
var animateHeadMenu = function (showX, menuHeightX, showStartX, head) {
    if (head === void 0) { head = true; }
    var menuElementX = patchElementClass('tophovermenu'); //** Class headMenuElement */
    var menuWrapperX = patchElement(head ? 'headsubmenu' : 'topsubmenu');
    if ((headMenuStore.show !== showX) || (isNil(menuElementX))) {
        // console.log(`${showStartX} ${showX?'Showing':'Hiding'} cancelled`);
        return true; // Show/hide was cancelled or  Menu has been removed
    }
    var progress = (Date.now() - showStartX) / transitionTime;
    // console.log(`${showStartX} ${showX?'Showing':'Hiding'} progress: ${progress}`);
    if (progress < 0.99) {
        menuElementX.style.bottom = menuHeightX * (showX ? 1 - progress : progress) + "px";
        menuWrapperX.style.height = menuHeightX * (showX ? progress : 1 - progress) + "px";
        headMenuStore = merge(headMenuStore, { actual: showX ? progress : 1 - progress });
        // Use the current menuElement height as it may take a few frames to stabilise
        window.requestAnimationFrame(function () { return animateHeadMenu(showX, menuElementX.offsetHeight, showStartX, head); });
    }
    else {
        menuElementX.style.bottom = showX ? "0px" : menuHeightX + "px";
        menuWrapperX.style.height = showX ? menuHeightX + "px" : '0px';
        headMenuStore = merge(headMenuStore, { actual: showX ? 1 : 0 });
        if (!showX) {
            patch(patchElement(head ? 'headsubmenu' : 'topsubmenu'), function () { });
        }
    }
};
var lastToggle;
var headMenuToggle = function (force, head) {
    if (head === void 0) { head = true; }
    if ((Date.now() - lastToggle) < 200) { // Debounce
        return;
    }
    if (headMenuStore.show === force) { // Exit if we are already at the force state
        return;
    }
    lastToggle = Date.now();
    var menuElement = patchElementClass('tophovermenu');
    if (!isNil(menuElement)) {
        headMenuStore.show = !headMenuStore.show;
        var showStart = Date.now() - (headMenuStore.show ? headMenuStore.actual : (1 - headMenuStore.actual)) * transitionTime;
        var currentShow = headMenuStore.show; // Need to fix to current scope
        animateHeadMenu(currentShow, menuElement.offsetHeight, showStart, head);
    }
};
var toggleSubMenu = function (dropmenu, force, head) {
    if (head === void 0) { head = true; }
    if (isNil(force) ? !headMenuStore.show : force) {
        patch(patchElement(head ? 'headsubmenu' : 'topsubmenu'), function () {
            elementOpen('div', null, null, 'class', 'tophovermenu');
            hoverMenuContent(dropmenu, window.location.pathname);
            elementClose('div');
        });
        headMenuToggle(true, head);
    }
    else {
        headMenuToggle(false, head);
    }
};
export { DropMenu };
//# sourceMappingURL=dropmenu.js.map